const INITIAL_VALUE = {
    versoes: [],
    versao: {},
    loading: false,
    processing: false
}

export default function VersaoAppReducer(state = INITIAL_VALUE, action) {
    switch (action.type) {
        case 'VERSAO_LOADING' :
            return { ...state, loading: action.payload };
        case 'VERSAO_PROCESSING' :
            return { ...state, processing: action.payload };
        case 'VERSOES_FETCHED':
            return { ...state, versoes: action.payload };
        case 'VERSAO_FETCHED':
            return { ...state, versao: action.payload };
        default:
            return state
    }
}